import React, { Component } from 'react';
import UgcVisualization from './UgcVisualization.container';

const UgcSelection = (props) => {
	const {
		challengeId,
		challenges,
		pathName,
		location,
	} = props;

	if (challengeId) {
		return <UgcVisualization />;
	}

	return (
		<div className="d-flex flex-column h-100">
			<div className="d-flex flex-grow-1 flex-column align-items-center justify-content-center">
				<h2>Challenges</h2>
				<ul>
					{
						Object.keys(challenges).map((id) => {
							const challenge = challenges[id];
							return (
								<li key={id}>
									<a href={`${pathName}${location.search || '?a=1'}&challengeId=${id}`}>
										{challenge.title}
									</a>
								</li>
							);
						})
					}
				</ul>
			</div>
		</div>
	);
};

export default UgcSelection;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/UgcSelection.component.js